module.exports = __webpack_public_path__ + "img/logo-white.3d3a8332.png";